import { useQuery } from 'react-query';
import { http } from '../api/http';
import { Home } from '../types/home';

export function useGetMyHome(homeId: String) {
  return useQuery<Home, any>(['get_my_home', homeId],()=> http.getMyHome(homeId));
}
